<div class="block flex-col gap-4 relative mb-6">

    @for (item of sessions$ | async; track $index) {

    <div class="bg-white shadow-lg rounded w-full px-4 py-3 mb-4">
        <a class="cursor-default flex flex-col gap-1">
            <!-- [routerLink]="[ 'students', item.memberId]" -->
            <div class="flex items-start justify-between flex-row w-full">
                <div class="flex flex-col">
                    <p class="text-primary-300 text-xs whitespace-nowrap">
                        {{ item.startDate.toDate() | moment: 'Do MMM YYYY hh:mm a' }}
                    </p>
                    <p class="font-semibold truncate text-nowrap">{{ item.sessionName }}</p>
                </div>
                @if (academicYear == group?.academicYear) {
                <div class="flex flex-row gap-2 whitespace-nowrap">
                    <app-btn-fab (click)="onSessionAttendance(item)" icon="fas fa-person-circle-check"
                        tooltip="Attendance"></app-btn-fab>
                    <app-btn-fab (click)="onEditSession(item)" icon="fas fa-edit"
                        tooltip="Update Session"></app-btn-fab>
                    <app-btn-fab (click)="onDeleteSession(item)" icon="fa fa-trash-can"
                        textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                </div>
                }
            </div>
            <p class="text-sm text-primary-400">Lesson: {{ item.lessonName }}</p>
            <div class="flex items-center gap-2">
                <div class="inline-block flex-none">
                    @if(item.teacherPhotoUrl) {
                    <img [src]="item.teacherPhotoUrl"
                        class="min-h-8 max-h-8 max-w-8 min-w-8 bg-gray-100 object-cover rounded-full border-none" />
                    } @else {
                    <div
                        class="bg-primary-100 uppercase text-primary-500 text-sm flex justify-center items-center text-center h-8 w-8 rounded-full">
                        {{ item.teacherName | initials }}
                    </div>
                    }
                </div>
                <div class="flex-1 inline-flex flex-span text-sm text-blueGray-600">
                    <span>{{item.teacherName}}</span>
                </div>
            </div>
        </a>
    </div>
    } @empty {
    @if(!(loading$ | async)) {
    <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
        No Sessions Found
    </div>
    }
    }
    @if((loading$ | async)) {
    <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
        <div class="animate-pulse flex space-x-4">
            <div class="flex-1 space-y-2">
                <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                <div class="space-y-2">
                    <div class="grid grid-cols-3 gap-4 mb-2">
                        <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                        <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="flex flex-row gap-2 justify-start items-center">
                        <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                        <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }

</div>

<div class="flex flex-row w-full justify-center px-4 mb-4 -mt-3">
    <button type="button" (click)="addMore()" [disabled]="(loading$ | async)"
        class="bg-white hover:bg-primary-100 active:bg-primary-500 active:text-white disabled:bg-primary-100 border-none shadow-lg text-xs rounded-full px-4 py-2">
        Show More
    </button>
</div>